import * as t from './actionTypes';

const errorCode = (error) => {
  // console.log('flight load error:', error);
  if (error && error.status === 429) {
    return 'TOO_MANY_REQUESTS';
  }
  return 'FLIGHTS_LOAD_ERROR1';
};

const initialState = {
  loading: false,
  loaded: false,
  pageIndex: 1,
  searchUrl: '',
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case t.LOAD_BY_DEPARTURE_AIRPORT_CARRIER_AND_DATE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case t.LOAD_BY_ARRIVAL_AIRPORT_CARRIER_AND_DATE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case t.LOAD_BY_ROUTE_CARRIER_AND_DATE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case t.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null,
      };
    case t.LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: {
          ...action.error,
          code: errorCode(action.error),
        },
      };
    case t.UPDATE_PAGE_INDEX:
      return {
        ...state,
        pageIndex: action.data.pageIndex,
        searchUrl: action.data.searchUrl,
      };
    case t.UPDATE_LOADED:
      return {
        ...state,
        loaded: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./modules/MultiFlight/redux/reducer.js